import CustomPageManipulationOperations from './CustomPageManipulationOperations';

export default CustomPageManipulationOperations;